module.exports = __webpack_public_path__ + "static/media/profile_17.08eef27f.jpg";